import React from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { FormattedMessage } from "react-intl";

const ProductGookToKnow = props =>{
    useStyles(classes);
    const { productHooks } = props;
    const { selectedProduct } = productHooks;

    return <React.Fragment>
        {
            selectedProduct?.beautyGoodToKnow?.length > 0 && <div className={classes.ProductGookToKnow}>
                <div className={classes.Hd}><FormattedMessage id="good_to_know" defaultMessage="good to know" /></div>

                <div className={classes.Bd}>
                    {
                        selectedProduct.beautyGoodToKnow.map((item,index)=>{
                            return <div className={classes.Item} key={index}>
                                <span className={classes.Icon} style={{background:`url(${item?.icon}) center top/100% no-repeat`}}></span>
                                <span className={classes.Font}>{item?.name}</span>
                            </div>
                        })
                    }
                </div>
            </div>
        }
        
    </React.Fragment>
}

export default ProductGookToKnow;